export default __webpack_public_path__ + "static/media/2-como-funciona.8971e8f0.png";